(function () {

    try {

        const BODY_CLASS = 'fe-hpe-4068';
        const BASE_HOST = window.location.hostname.includes('uatc') ? 'https://uatc.buy.hpe.com' : 'https://buy.hpe.com';
        const TERMS_URL = '/hpe_amd_rebate_promo_solution_SMB';
        const REBATE_CLAIM_URL = 'https://amdhperebates.com';

        /**
         * VME SKU mapping by country — first option (1-year) from VMEssentials.xlsx.
         * pdpPath is the path after baseUrl() for each country's PDP.
         */
        const VME_SKU_MAP = {
            us: {
                pdpPath: '/software/virtualization-software/morpheus-software/morpheus-software/hpe-morpheus-vm-essentials-software/p/s5q81aae',
                models: [
                    {sku: 'S5Q81AAE', name: 'HPE Morpheus VM Essentials Software per Socket 1‑year E‑LTU'},
                    {sku: 'S5Q82AAE', name: 'HPE Morpheus VM Essentials Software per Socket 3‑year E‑LTU'},
                    {sku: 'S5Q83AAE', name: 'HPE Morpheus VM Essentials Software per Socket 5‑year E‑LTU'}
                ]
            },
            uk: {
                pdpPath: '/enterprise-solutions/greenlake-solutions/greenlake-private-cloud-solutions/greenlake-on-premise-solutions/hpe-greenlake-dedicated-software/p/s6m14aae',
                models: [
                    {sku: 'S6M14AAE', name: 'HPE Morpheus VM Essentials Software for Dedicated Platform 1‑year E‑LTU'},
                    {sku: 'S6P47AAE', name: 'HPE Morpheus VM Essentials Software for Dedicated Platform 6‑year E‑LTU'},
                    {sku: 'S6P48AAE', name: 'HPE Morpheus VM Essentials Software for Dedicated Platform 7‑year E‑LTU'}
                ]
            },
            ca: {
                pdpPath: '/enterprise-solutions/greenlake-solutions/greenlake-private-cloud-solutions/greenlake-on-premise-solutions/hpe-greenlake-dedicated-software/p/s6m14aae',
                models: [
                    {sku: 'S6M14AAE', name: 'HPE Morpheus VM Essentials Software for Dedicated Platform 1‑year E‑LTU'},
                    {sku: 'S6P47AAE', name: 'HPE Morpheus VM Essentials Software for Dedicated Platform 6‑year E‑LTU'},
                    {sku: 'S6P48AAE', name: 'HPE Morpheus VM Essentials Software for Dedicated Platform 7‑year E‑LTU'}
                ]
            },
            fr: {
                pdpPath: '/enterprise-solutions/greenlake-solutions/greenlake-private-cloud-solutions/greenlake-on-premise-solutions/hpe-greenlake-dedicated-software/p/s6m14aae',
                models: [
                    {sku: 'S6M14AAE', name: 'HPE Morpheus VM Essentials Software for Dedicated Platform 1‑year E‑LTU'},
                    {sku: 'S6P47AAE', name: 'HPE Morpheus VM Essentials Software for Dedicated Platform 6‑year E‑LTU'},
                    {sku: 'S6P48AAE', name: 'HPE Morpheus VM Essentials Software for Dedicated Platform 7‑year E‑LTU'}
                ]
            }
        };

        /**
         * Known AMD server model identifiers (model number ends in 5).
         * Deliberately an allowlist rather than a generic "model ends in 5" rule —
         * cart line items include accessories and spares whose descriptions carry
         * unrelated numbers ending in 5 (battery part sizes, cable lengths). Models
         * missing from this list are not lost: they fall through to the
         * classification lookup in isAmdServerUsingSpecs, which is authoritative.
         */
        const AMD_MODEL_IDENTIFIERS = [
            'DL145',
            'DL325',
            'DL345',
            'DL365',
            'DL385',
            'XD685'
        ];

        /**
         * Classification feature-code suffixes carrying authoritative processor
         * identity, with the values they return:
         *   facet_processorbrand → 'AMD' | 'Intel'
         *   facet_processortype  → 'AMD EPYC™ 9124' | 'Intel® Xeon® 6515P'
         *   processorname        → 'AMD EPYC™ 9124 (16 core, 3.00 GHz, 64 MB L3, 200W)'
         * Only these are inspected for an AMD match — see isAmdServerUsingSpecs.
         */
        const PROCESSOR_FEATURE_SUFFIXES = [
            '.facet_processorbrand',
            '.facet_processortype',
            '.processorname'
        ];

        const SEL = {
            buyOnlineTab: '#buyOnlineSelector',
            // Confirmation page (PROD + UATC) — line-item wrapper / name.
            sectionBody: '.hpe-cart-list__section-body',
            itemName: '.item__name',
            // Cart page — line items render differently on PROD vs UATC, so the
            // selectors below cover both structures.
            //   PROD: .hpe-cart-list__section-body > .item__name
            //   UATC: .product-block             > .cart-font-name
            cartItemContainer: '.hpe-cart-list__section-body, .product-block',
            cartItemName: '.item__name, .cart-font-name',
            cartItemAttach: '.cart-details-block', // UATC-only append slot
            productCode: 'input[name="productCode"]',
            // Quantity form carries a data-cart JSON blob with a clean numeric
            // productPostPrice (e.g. "4972.0"); visible money text is the fallback.
            cartPriceForm: 'form.js-qty-form',
            cartLineMoney: '.hpe-cart-list__money',
            promoCard: '.fe-vme-promo-card',
            skuLabel: 'strong.hpe-label--inline'
        };

        let txt = {
            PromoText: 'Add an HPE Morpheus VM Essentials license and get a $500 rebate',
            CartPageLimitedTime: 'Limited time and while supplies last',
            CartPageReadOffer: 'read offer Terms and Conditions',
            ReadTerms: 'Read terms and conditions',
            AddLabel: 'Add to cart',
            EmailSentPrefix: 'We sent an email to',
            EmailSentSuffix: 'with your order confirmation and receipt.',
            RebateMessage: 'Submit your rebate claim at',
            SubmitClaim: 'Submit claim'
        };

        const REBATE_LINK_TEXT = 'https://amdhperebates.com/';

        let cachedVmeData = null;

        /**
         * Fetch HTML with sessionStorage caching (mirrors cachedFetchJson pattern).
         * @param {string} url
         * @param {function} cb - callback receiving the HTML string
         * @param {object} [ops] - options: storeType, cacheTtl, onError
         */
        function cachedFetchHtml(url, cb, ops) {
            ops = ops || {};
            cb = cb || function () {
            };
            const cacheTtl = ops.cacheTtl || 60 * 10; // 10 min
            const key = 'FE::html::' + url;
            const now = Math.floor(Date.now() / 1000);
            const storage = ops.storeType === 'local' ? localStorage : sessionStorage;

            const cached = storage.getItem(key);
            if (cached) {
                try {
                    const parsed = JSON.parse(cached);
                    if (parsed && parsed.resp && parsed.epoch && (parsed.epoch + cacheTtl) >= now) {
                        return cb(parsed.resp);
                    }
                } catch (err) {
                    window['feHPEB2C'].log('FE:4068: cachedFetchHtml cache parse error', err);
                }
                storage.removeItem(key);
            }

            const saltedUrl = url + (url.indexOf('?') < 0 ? '?' : '&') +
                '_salt=' + Math.floor(now / (cacheTtl / 2));

            fetch(saltedUrl)
                .then(function (resp) {
                    return resp.text();
                })
                .then(function (html) {
                    try {
                        storage.setItem(key, JSON.stringify({epoch: now, resp: html}));
                    } catch (err) {
                        window['feHPEB2C'].log('FE:4068: cachedFetchHtml storage error', err);
                    }
                    cb(html);
                })
                .catch(function (err) {
                    window['feHPEB2C'].log('FE:4068: cachedFetchHtml fetch error', err);
                    if (ops.onError) ops.onError(err);
                });
        }

        /** Check if a product name contains a known AMD server model identifier */
        function isAmdServer(productName) {
            return AMD_MODEL_IDENTIFIERS.some(model => productName.includes(model));
        }

        /** Is this classification feature code an authoritative processor field? */
        function isProcessorFeature(code) {
            if (typeof code !== 'string') return false;
            return PROCESSOR_FEATURE_SUFFIXES.some(suffix => code.endsWith(suffix));
        }

        /**
         * Fallback AMD detection: fetch the classification/specs endpoint for a SKU
         * and check its processor fields for an AMD processor.
         *
         * Only the processor fields listed in PROCESSOR_FEATURE_SUFFIXES are
         * inspected. Matching "AMD" against every featureValue in the payload
         * produces false positives, because the payload also carries marketing and
         * legal copy naming AMD on non-AMD servers:
         *   - Messaging_MarketingTopicalOutline.desctiptionmetatag on the Intel
         *     DL320 Gen12 (P87776-005) reads "...powered by AMD EPYC 6515P...",
         *     an error in HPE's own meta description — 6515P is an Intel Xeon.
         *   - Messaging_LegalInformation.trademark carries the "AMD and AMD EPYC
         *     are trademarks of Advanced Micro Devices" boilerplate.
         * That whole-payload scan is what put the promo on non-AMD SKUs
         * (ClickUp 86e2nnpay).
         *
         * Non-server SKUs (software, accessories) carry no processor fields, so
         * they return false.
         */
        function isAmdServerUsingSpecs(sku, callback) {
            const specUrl = BASE_HOST + window['feHPEB2C'].baseUrl() +
                '/compute/p/classification?variantCode=' + encodeURIComponent(sku);
            window['feHPEB2C'].cachedFetchJson(specUrl, function (result) {
                let isAmd = false;
                try {
                    for (const compKey in result) {
                        const features = result[compKey]?.features || [];
                        for (let i = 0; i < features.length; i++) {
                            if (!isProcessorFeature(features[i]?.code)) continue;
                            const values = features[i]?.featureValues || [];
                            for (let j = 0; j < values.length; j++) {
                                const val = values[j]?.value;
                                if (typeof val === 'string' && val.toUpperCase().includes('AMD')) {
                                    isAmd = true;
                                    break;
                                }
                            }
                            if (isAmd) break;
                        }
                        if (isAmd) break;
                    }
                } catch (err) {
                    window['feHPEB2C'].log('FE:4068: isAmdServerUsingSpecs parse error', err);
                }
                window['feHPEB2C'].log('FE:4068: isAmdServerUsingSpecs', sku, isAmd);
                callback(isAmd);
            });
        }

        /** Get VME SKU info for the current country, or null if not targeted */
        function getVmeInfo() {
            const country = window['feHPEB2C'].findTargetCountry();
            // TEMPORARY (ClickUp 4068 / 86e1x19a4): the non-US VME SKUs are currently
            // unavailable, so serve the US SKU set for every targeted country. The
            // non-US entries remain in VME_SKU_MAP for when they're reactivated —
            // restore the original line below to revert:
            //   return VME_SKU_MAP[country] || null;
            return VME_SKU_MAP[country] ? VME_SKU_MAP.us : null;
        }

        /**
         * Extract the parent line-item price from a cart container.
         * Prefers the clean numeric productPostPrice on the quantity form's
         * data-cart JSON; falls back to the visible line-item money text.
         * @param {Element} container - cart line-item container
         * @returns {string|number} number when available, else currency string, else ''
         */
        function getParentPrice(container) {
            const priceForm = container.querySelector(SEL.cartPriceForm);
            const dataCart = priceForm?.getAttribute('data-cart');
            if (dataCart) {
                try {
                    const parsed = JSON.parse(dataCart);
                    const postPrice = Number(parsed?.productPostPrice);
                    if (Number.isFinite(postPrice)) return postPrice;
                } catch (err) {
                    window['feHPEB2C'].log('FE:4068: getParentPrice data-cart parse error', err);
                }
            }
            return container.querySelector(SEL.cartLineMoney)?.textContent?.trim() || '';
        }

        /**
         * Build a single Adobe product entry (productInfo shape) for
         * feTrackMetrics `products`. Mirrors the element shape HPE's B2C data
         * layer publishes at dataLayer[].b2c_xdm.cartDetail.item /
         * dataLayer[].b2c_xdm.productInfo (the successor to the removed
         * window.digitalData object).
         * @param {string} productID - product ID / SKU
         * @param {string} [productName]
         * @param {string|number} [price] - currency string (e.g. "$1,234.56") or number
         * @returns {{productInfo: {productID: string, productName: string, quantity: number, price: number|null}}}
         */
        function buildTrackingProduct(productID, productName, price) {
            let priceNum = null;
            if (typeof price === 'number' && Number.isFinite(price)) {
                priceNum = price;
            } else if (typeof price === 'string' && price) {
                // Omit the country arg: currencyToNumber only uppercases the code
                // when it derives it itself (findTargetCountry() returns lowercase,
                // but feReusable.currencies is keyed uppercase, so passing it fails).
                const parsed = window['feReusable']?.currencyToNumber?.(price);
                priceNum = Number.isFinite(parsed) ? parsed : null;
            }
            return {
                productInfo: {
                    productID: productID || '',
                    productName: productName || '',
                    quantity: 1,
                    price: priceNum
                }
            };
        }

        /** Check if any VME model SKU is already in the cart */
        // function isVmeAlreadyInCart(vmeInfo) {
        //     const allProductCodes = document.querySelectorAll(SEL.productCode);
        //     const vmeSkus = vmeInfo.models.map(function (m) { return m.sku.toUpperCase(); });
        //     for (let i = 0; i < allProductCodes.length; i++) {
        //         const code = (allProductCodes[i].value || '').toUpperCase();
        //         if (vmeSkus.indexOf(code) >= 0) return true;
        //     }
        //     return false;
        // }

        /**
         * Extract price, fulfiller, and add-to-cart form from a single PDP HTML doc.
         * @returns {{ price: string, fulfiller: string, formHtml: string }}
         */
        function parsePdpHtml(html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');

            // Price: label.priceTotal or span.hpeit-options-price
            const price = doc.querySelector('label.priceTotal')?.textContent?.trim() ||
                doc.querySelector('span.hpeit-options-price')?.textContent?.trim() || '';

            // Fulfiller / reseller
            const fulfiller = doc.querySelector('span.hpeit-options-reseller-name')?.textContent?.trim() ||
                doc.querySelector('span.hpeit-options-reseller')?.textContent?.trim() || '';

            // Add-to-cart form — pick the one whose action posts to /cart/add
            let formHtml = '';
            const allForms = doc.querySelectorAll('form.add_to_cart_form');
            allForms.forEach(function (f) {
                if (formHtml) return;
                if (f.action && f.action.includes('/cart/add')) {
                    formHtml = f.outerHTML;
                }
            });

            return {price: price, fulfiller: fulfiller, formHtml: formHtml};
        }

        /**
         * Fetch VME product data (prices, fulfillers, add-to-cart forms).
         * Each model has its own PDP page, so we fetch each one in parallel
         * and merge results back onto the config model list.
         */
        function fetchVmeData(vmeInfo, callback) {
            if (cachedVmeData) {
                callback(cachedVmeData);
                return;
            }

            const configModels = vmeInfo.models || [];
            const baseUrl = BASE_HOST + window['feHPEB2C'].baseUrl();
            // pdpPath ends with /p/{sku} — swap the trailing sku per model
            const pdpBase = vmeInfo.pdpPath.replace(/[^/]+$/, '');

            const models = configModels.map(function (cm) {
                return {
                    sku: cm.sku,
                    name: cm.name,
                    price: '',
                    fulfiller: '',
                    formHtml: '',
                    pdpUrl: baseUrl + pdpBase + cm.sku.toLowerCase()
                };
            });
            let completed = 0;

            function checkDone() {
                completed++;
                if (completed === configModels.length) {
                    // HPE renders the add-to-cart form shell even when no reseller
                    // can fulfill the SKU in this country (e.g., S6M14AAE on CA — the
                    // form sits inside a .hidden wrapper). The reseller-options markup
                    // that supplies price + fulfiller is absent in that case, so both
                    // come back empty. Require all three before offering the SKU.
                    const availableModels = models.filter(function (m) {
                        return !!m.formHtml && !!m.price && !!m.fulfiller;
                    });
                    const skipped = models.length - availableModels.length;
                    cachedVmeData = {models: availableModels};
                    window['feHPEB2C'].log('FE:4068: VME product data loaded',
                        availableModels.length + ' available, ' + skipped + ' skipped (no partner offer)');
                    callback(cachedVmeData);
                }
            }

            configModels.forEach(function (cm, idx) {
                const pdpUrl = baseUrl + pdpBase + cm.sku.toLowerCase();
                window['feHPEB2C'].log('FE:4068: Fetching VME PDP for', cm.sku);

                cachedFetchHtml(pdpUrl, function (html) {
                    const data = parsePdpHtml(html);
                    models[idx] = {
                        sku: cm.sku,
                        name: cm.name,
                        price: data.price,
                        fulfiller: data.fulfiller,
                        formHtml: data.formHtml,
                        pdpUrl: pdpUrl
                    };
                    checkDone();
                }, {
                    onError: function () {
                        window['feHPEB2C'].log('FE:4068: PDP fetch failed for', cm.sku);
                        checkDone();
                    }
                });
            });
        }

        /**
         * Build a single model row matching the cart line-item style.
         * @param {object} model - recommended VME model (sku, name, price, ...)
         * @param {string} parentSku - SKU of the cart line item this promo hangs off
         * @param {string} parentName - product name of that parent cart line item
         * @param {string|number} parentPrice - price of that parent cart line item
         */
        function buildModelRow(model, parentSku, parentName, parentPrice) {
            const csrfToken = window['feReusable']?.getCSRFToken?.() || '';
            const row = document.createElement('div');
            row.className = 'fe-vme-model-row';

            // Left side: name + SKU
            const infoEl = document.createElement('div');
            infoEl.className = 'fe-vme-model-info';

            // Product name reuses the cart page's own product-link styling: mirror
            // the `.hpe-cart-list__section-product > a > span` structure so the native
            // cart rule `.hpe-cart-list__section-product a span` supplies the link
            // color and weight. Opens the PDP in a new tab.
            //   - Use a <div> rather than the cart's <h3> so we don't inject spurious
            //     headings into the page outline; the native rule keys off the class.
            //   - The <span> is intentionally classless — the rule targets the
            //     descendant span, and omitting `item__name` avoids colliding with
            //     this activity's own cart line-item name detection (SEL.cartItemName).
            const nameEl = document.createElement('div');
            nameEl.className = 'fe-vme-model-name hpe-cart-list__section-product';
            const nameLink = document.createElement('a');
            const nameText = document.createElement('span');
            nameText.textContent = model.name;
            nameLink.appendChild(nameText);
            if (model.pdpUrl) {
                nameLink.href = model.pdpUrl;
                nameLink.target = '_blank';
                nameLink.rel = 'noopener noreferrer';
            }
            nameEl.appendChild(nameLink);
            infoEl.appendChild(nameEl);

            const skuEl = document.createElement('div');
            skuEl.className = 'fe-vme-model-sku';
            skuEl.textContent = 'SKU: ' + model.sku;
            infoEl.appendChild(skuEl);

            row.appendChild(infoEl);

            // Right side: price + fulfiller
            const priceBlock = document.createElement('div');
            priceBlock.className = 'fe-vme-model-price-block';

            if (model.price) {
                const priceEl = document.createElement('div');
                priceEl.className = 'fe-vme-model-price';
                priceEl.textContent = model.price;
                priceBlock.appendChild(priceEl);
            }

            if (model.fulfiller) {
                const fulfillerEl = document.createElement('div');
                fulfillerEl.className = 'fe-vme-model-fulfiller';
                fulfillerEl.textContent = model.fulfiller;
                priceBlock.appendChild(fulfillerEl);
            }

            row.appendChild(priceBlock);

            // Form — clone from PDP or build manually
            let form;
            if (model.formHtml) {
                const wrapper = document.createElement('div');
                wrapper.innerHTML = model.formHtml;
                form = wrapper.firstElementChild;
                const csrfInput = form.querySelector('input[name="CSRFToken"]');
                if (csrfInput) csrfInput.value = csrfToken;
            }
            if (!form) {
                const baseUrl = window['feHPEB2C'].baseUrl();
                form = document.createElement('form');
                form.className = 'add_to_cart_form';
                form.action = baseUrl + '/cart/add';
                form.method = 'post';
                const productInput = document.createElement('input');
                productInput.type = 'hidden';
                productInput.name = 'productCodePost';
                productInput.value = model.sku;
                form.appendChild(productInput);
                if (csrfToken) {
                    const csrfEl = document.createElement('input');
                    csrfEl.type = 'hidden';
                    csrfEl.name = 'CSRFToken';
                    csrfEl.value = csrfToken;
                    form.appendChild(csrfEl);
                }
            }
            form.classList.add('fe-vme-add-form');

            const originalBtn = form.querySelector('button[class*="add-cart-btn"]');
            if (originalBtn) {
                originalBtn.style.display = 'none';
                originalBtn.removeAttribute('disabled');
            }

            const addBtn = document.createElement('button');
            addBtn.type = 'button';
            addBtn.className = 'fe-vme-add-btn';
            addBtn.setAttribute('aria-label', txt.AddLabel);
            addBtn.textContent = '+';
            addBtn.addEventListener('click', function () {
                // Record both the parent (AMD server already in cart) and the
                // recommended VME SKU being added.
                const products = [
                    buildTrackingProduct(parentSku, parentName, parentPrice),
                    buildTrackingProduct(model.sku, model.name, model.price)
                ];
                feTrackMetrics('new.link', {link_name: 'mp:cart:recommendation:amd-vme:add-to-cart', products: products});
                const formData = new FormData(form);
                const urlEncoded = new URLSearchParams(formData).toString();
                fetch(form.action, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        'x-requested-with': 'XMLHttpRequest'
                    },
                    body: urlEncoded,
                    credentials: 'include'
                }).then(function () {
                    window.location.href = window.location.href;
                }).catch(function (err) {
                    window['feHPEB2C'].log('FE:4068: Add to cart failed', err);
                    window.location.href = window.location.href;
                });
            });
            form.appendChild(addBtn);
            row.appendChild(form);

            return row;
        }

        /**
         * Build the VME promotional section (inline with cart, no banner).
         * @param {object} vmeData - {models: [...]}
         * @param {string} parentSku - SKU of the cart line item this promo hangs off
         * @param {string} parentName - product name of that parent cart line item
         * @param {string|number} parentPrice - price of that parent cart line item
         */
        function buildPromoCard(vmeData, parentSku, parentName, parentPrice) {
            const $card = $('<details>', {'class': 'fe-vme-promo-card', open: true});

            const termsHref = BASE_HOST + window['feReusable'].baseUrl() + TERMS_URL;
            $card.append(`
                <summary class="fe-vme-promo-summary">
                    <p class="fe-vme-promo-text">${txt.PromoText}</p>
                    <span class="fe-vme-promo-subtext">${txt.CartPageLimitedTime} -
                        <a class="fe-vme-terms-link" href="${termsHref}" target="_blank" rel="noopener noreferrer">${txt.CartPageReadOffer}</a>
                    </span>
                </summary>
            `);

            // One row per model: name + SKU | price + fulfiller | [+]
            vmeData.models.forEach(function (model) {
                const row = buildModelRow(model, parentSku, parentName, parentPrice);
                if (row) $card.append(row);
            });

            return $card[0];
        }

        // ======================================================================
        //  Cart Page
        // ======================================================================

        /**
         * Resolve the visible append target inside a cart line item.
         * On PROD the item container is block-level, so we append to it directly.
         * On UATC the container (.product-block) is a flex row whose right column
         * is .cart-details-block — appending there keeps the promo under the
         * product info instead of as a stray flex column.
         */
        function getCartPromoTarget(itemContainer) {
            if (itemContainer.classList.contains('product-block')) {
                return itemContainer.querySelector(SEL.cartItemAttach) || itemContainer;
            }
            return itemContainer;
        }

        function initCart() {
            const vmeInfo = getVmeInfo();
            if (!vmeInfo) {
                window['feHPEB2C'].log('FE:4068: Country not in VME target list, skipping');
                return;
            }

            // Don't show promo if VME is already in the cart
            // if (isVmeAlreadyInCart(vmeInfo)) {
            //     window['feHPEB2C'].log('FE:4068: VME already in cart, skipping promo');
            //     return;
            // }

            const buyOnlineTab = document.querySelector(SEL.buyOnlineTab);
            if (!buyOnlineTab) {
                window['feHPEB2C'].log('FE:4068: Buy Online tab not found');
                return;
            }

            // Anchor on the per-item productCode input — it's present on both
            // PROD and UATC even though their item containers differ. Then walk
            // up to the closest item container for each.
            const productInputs = buyOnlineTab.querySelectorAll(SEL.productCode);
            const amdContainers = [];
            const unknownContainers = [];
            const seenContainers = new Set();

            productInputs.forEach(function (input) {
                const container = input.closest(SEL.cartItemContainer);
                if (!container || seenContainers.has(container)) return;
                seenContainers.add(container);

                const nameEl = container.querySelector(SEL.cartItemName);
                const productName = nameEl?.textContent?.trim() || '';
                if (productName && isAmdServer(productName)) {
                    amdContainers.push(container);
                } else {
                    unknownContainers.push(container);
                }
            });

            function injectPromos(containers) {
                if (containers.length === 0) return;
                window['feHPEB2C'].log('FE:4068: Found ' + containers.length + ' AMD server(s), fetching VME data');
                fetchVmeData(vmeInfo, function (vmeData) {
                    if (!vmeData.models.length) {
                        window['feHPEB2C'].log('FE:4068: No VME SKUs available from partners for this country, skipping promo');
                        return;
                    }
                    containers.forEach(function (container) {
                        const target = getCartPromoTarget(container);
                        if (target.querySelector(SEL.promoCard)) return; // guard against double-injection

                        const parentSku = (container.querySelector(SEL.productCode)?.value || '').trim();
                        const parentName = container.querySelector(SEL.cartItemName)?.textContent?.trim() || '';
                        const parentPrice = getParentPrice(container);

                        const card = buildPromoCard(vmeData, parentSku, parentName, parentPrice);
                        target.appendChild(card);

                        // Page-load impression: record the parent SKU that earned a recommendation.
                        feTrackMetrics('new.link', {
                            link_name: 'mp:cart:recommendation:amd-vme:impression',
                            products: [buildTrackingProduct(parentSku, parentName, parentPrice)]
                        });
                    });
                });
            }

            injectPromos(amdContainers);

            // For items whose name didn't match a known AMD identifier,
            // fall back to looking up specs via the classification endpoint.
            unknownContainers.forEach(function (container) {
                const skuEl = container.querySelector(SEL.productCode);
                const sku = skuEl?.value;
                if (!sku) return;
                isAmdServerUsingSpecs(sku, function (isAmd) {
                    if (isAmd) injectPromos([container]);
                });
            });
        }

        // ======================================================================
        //  Checkout Confirmation Page
        // ======================================================================

        /**
         * Pull the plain-text SKU out of a confirmation-page line section.
         * Markup looks like: <strong class="hpe-label--inline">SKU #</strong>JL255A
         */
        function extractConfirmationSku(section) {
            const strongs = section.querySelectorAll(SEL.skuLabel);
            for (let i = 0; i < strongs.length; i++) {
                const labelText = (strongs[i].textContent || '').toUpperCase();
                if (!labelText.includes('SKU')) continue;
                const parent = strongs[i].parentElement;
                if (!parent) continue;
                const parts = parent.textContent.split('#');
                if (parts.length > 1) return parts[1].trim();
            }
            return '';
        }

        /**
         * Check whether any line item on the confirmation page is a VME SKU
         * for the current country (per VME_SKU_MAP).
         */
        function doesConfirmationPageHaveVmeItem() {
            const vmeInfo = getVmeInfo();
            if (!vmeInfo) return false;

            const vmeSkus = vmeInfo.models.map(function (m) {
                return m.sku.toUpperCase();
            });
            const $sections = $(SEL.sectionBody);
            if (!$sections.length) return false;

            let found = false;
            $sections.each(function () {
                if (found) return;
                const sku = extractConfirmationSku(this);
                if (sku && vmeSkus.indexOf(sku.toUpperCase()) >= 0) {
                    found = true;
                }
            });
            return found;
        }

        /**
         * Pull the customer email from the confirmation page's address summary.
         * Markup: <div class="hpe-form-view-title ...">Email</div>
         *         <div class="hpe-form-view">name@example.com</div>
         */
        function getCustomerEmail() {
            let email = '';
            $('.hpe-summary-address__row').each(function () {
                const $row = $(this);
                const label = $row.find('.hpe-form-view-title').text().trim().toLowerCase();
                if (label === 'email') {
                    email = $row.find('.hpe-form-view').text().trim();
                    return false;
                }
                return undefined;
            });
            return email;
        }

        function injectRebateMessage() {
            const $headlineContainer = $('.checkout-success__body__headline').first();
            if (!$headlineContainer.length) {
                window['feHPEB2C'].log('FE:4068: Thank You heading not found on confirmation page');
                return;
            }

            // Already injected — bail out
            if ($headlineContainer.find('.fe-vme-rebate-card').length) return;

            $headlineContainer.addClass('fe-vme-headline-wrap');

            const email = getCustomerEmail();

            const $card = $('<div>', {'class': 'fe-vme-rebate-card'});
            const $copy = $('<p>', {'class': 'fe-vme-rebate-copy'});

            if (email) {
                $copy.append(document.createTextNode(txt.EmailSentPrefix + ' '));
                $copy.append($('<span>', {'class': 'fe-vme-rebate-email', text: email}));
                $copy.append(document.createTextNode(' ' + txt.EmailSentSuffix + ' '));
            }

            const $claimText = $('<strong>', {'class': 'fe-vme-rebate-claim'});
            $claimText.append(document.createTextNode(txt.RebateMessage + ' '));
            $claimText.append($('<span>', {'class': 'fe-vme-rebate-url', text: REBATE_LINK_TEXT}));
            $copy.append($claimText);

            $card.append($copy);

            const $btn = $('<a>', {
                'class': 'fe-vme-submit-claim-btn',
                href: REBATE_CLAIM_URL,
                target: '_blank',
                rel: 'noopener noreferrer',
                text: txt.SubmitClaim
            });
            $btn.on('click', function () {
                feTrackMetrics('new.link', {link_name: 'mp:order-confirmation:amd-vme:submit-claim'});
            });

            $card.append($btn);
            $headlineContainer.append($card);

            window['feHPEB2C'].log('FE:4068: Rebate card inserted next to Thank You heading');
        }

        function initCheckoutConfirmation() {
            if (!doesConfirmationPageHaveVmeItem()) {
                window['feHPEB2C'].log('FE:4068: No VME item found on order, skipping rebate message');
                return;
            }
            injectRebateMessage();
        }

        // ======================================================================
        //  Init
        // ======================================================================

        function init() {
            document.body.classList.add(BODY_CLASS);
            window['FEi18n'].ask(txt);

            const currentUrl = window.location.href;
            if (currentUrl.includes('/cart')) {
                initCart();
            } else if (currentUrl.includes('/checkout/orderConfirmation')) {
                initCheckoutConfirmation();
            }
        }

        window.feUtils.waitForConditions({
            conditions: ['body', function () {
                return window['FEi18n']?.isReady();
            }],
            activity: feProjectId,
            callback: init,
        });

    } catch (e) {
        window['feHPEB2C'].log('FE:4068: Uncaught error, aborting script', e);
    }

})();
